import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import Carousel from '../../components/Carousel';
import DefaultCard from '../../components/DefaultCard';
import FingerTipsLinks from '../../components/FingertipsLinks/FingertipsLinks';
import {
  HwDashboardProvider,
  HwDashboardStore,
} from '../../providers/hwDashboard';
import {
  COBRA_BENEFITS_ENROLLMENT_ROUTE,
  HEALTH_INSURANCE_ROUTH,
  LIFE_EVENTS_ROUTE,
  PAYMENT_INFO_ROUTE,
  PROFILE_ROUTE,
  HEALTH_SAVINGS_AND_SPENDINGS_INACTIVE,
} from '../../routes/types';
import { formatDate } from '../../utils/utils';
import HealthSavingsAndSpending from '../widgets/dashboards/HealthSavingsAndSpending';
import HealthSnapshot from '../widgets/dashboards/HealthSnapshot';

const linksData = [
  {
    linkHeader: 'More Details',
    route: `${HEALTH_INSURANCE_ROUTH}`,
  },

  {
    linkHeader: 'Change Coverage',
    route: `${LIFE_EVENTS_ROUTE}`,
  },

  {
    linkHeader: 'Payment Information',
    route: `${PAYMENT_INFO_ROUTE}`,
  },

  {
    linkHeader: 'Beneficiaries',
    route: `${PROFILE_ROUTE.slice(0, 9)}beneficiaries`,
  },

  {
    linkHeader: 'Family Members',
    route: `${PROFILE_ROUTE.slice(0, 9)}familymembers`,
  },
];

const accruedPensionData = [
  {
    title: 'HRA',
    subtitle: 'Health Reimbursement Arrangement',
    priceDescription: 'Available',
    balance: 2339.18,
  },
];

const HwInactiveDashboardView = () => {
  const {
    fingertipLinks,
    healthSnapshot,
    companiesMessages,
    coveredFamilyMembers,
  } = useContext(HwDashboardStore) || {};
  const navigate = useNavigate();

  const date = new Date();

  return (
    <Container className={'cnd-custom-container-large mb-12 px-lg-9 px-xl-0'}>
      <Row>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-7">
          <DefaultCard
            className="h-100 flex-column flex-sm-row "
            variant="blue-motif"
            leftHeading={
              <div className="text-sm-20-lg-32">Retirement Enrollment</div>
            }
            leftSubheading={
              <div className="text-sm-12-lg-14 fw-light mb-7">
                {`Due: ${formatDate(
                  new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate() + 25
                  )
                )} at 11:59PM EST`}
              </div>
            }
            button={
              <Button
                className="align-self-end"
                variant="primary-shadow"
                size="sm"
                onClick={() => navigate(COBRA_BENEFITS_ENROLLMENT_ROUTE)}
              >
                Enroll Now
              </Button>
            }
          />
        </Col>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-5">
          <DefaultCard
            className="flex-column"
            variant="blue"
            leftHeading={<div className="text-sm-20-lg-32">Current Events</div>}
            leftSubheading={
              <Container className="p-0 mb-10">
                <Row className="text-sm-12-lg-14 fw-light p-0">
                  <Col className="text-nowrap col-7 fw-light">
                    {`There are currently no events.`}
                  </Col>
                </Row>
              </Container>
            }
          />
        </Col>
      </Row>

      <Row className="d-flex justify-content-between">
        <Col
          className={'d-flex flex-column pt-lg-8 col-12 col-lg-7 mt-10 mt-lg-8'}
        >
          <HealthSnapshot
            coveredFamilyMembers={coveredFamilyMembers}
            linksData={linksData}
          />
        </Col>
        <Col className="pe-lg-0 mt-12 mt-lg-8 pt-lg-8 col-12 col-lg-5">
          <FingerTipsLinks data={fingertipLinks} className="p-0 pe-5" />
        </Col>
      </Row>

      <Row className="m-0 d-flex justify-content-between">
        <Col
          className={
            'm-0 p-0 d-flex flex-column pt-lg-6 col-12 col-lg-6 mt-10 mt-lg-6 pe-lg-4'
          }
        >
          <HealthSavingsAndSpending
            detailsRoute={HEALTH_SAVINGS_AND_SPENDINGS_INACTIVE}
            accruedPensionData={accruedPensionData}
          />
        </Col>
      </Row>

      <Row className="m-0 mt-12 p-0">
        <Carousel data={companiesMessages} />
      </Row>
    </Container>
  );
};

const HwInactiveDashboard = () => {
  return (
    <HwDashboardProvider>
      <HwInactiveDashboardView />
    </HwDashboardProvider>
  );
};

export default HwInactiveDashboard;
